import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=27ed132f&scoped=true&"
import script from "./Income.vue?vue&type=script&lang=js&"
export * from "./Income.vue?vue&type=script&lang=js&"
import style0 from "./Income.vue?vue&type=style&index=0&id=27ed132f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed132f",
  null
  
)

export default component.exports